export default __webpack_public_path__ + "static/media/element_62.c2699737.avif";